module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myclass",
    attrs: {
      "id": "نرجسية"
    }
  }, [_c('div', {
    staticClass: "section level2",
    staticStyle: {
      "padding-top": "130px"
    },
    attrs: {
      "id": "narcissistic"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنت لا تعرف كُلَّ شيء، لذا لا تتوقع الكثير.")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("You don’t know anything, so don’t expect more.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندما ترفع سقف التوقعات بأعمدة ليست ثابتة؛ سينهار عليك ويقتلك.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("When your expectations are so high, they may fall")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("upon you and kill you.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("******")]), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd355748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0007.vue
// module id = 105
// module chunks = 0